import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateScalar: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export enum AMOUNT_OPTIONS {
  GT5_LT10 = 'GT5_LT10',
  GT10_LT15 = 'GT10_LT15',
  GT15 = 'GT15',
  LT5 = 'LT5'
}

export type BackofficeRegister = {
  __typename?: 'BackofficeRegister';
  curationReview?: Maybe<BackofficeRegisterRatingReview>;
  curationReviewPoints?: Maybe<Scalars['Int']['output']>;
  currentReviewProcess?: Maybe<REVIEW_PROCESS>;
  currentReviewer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  registerContent: Register;
  selected: Scalars['Boolean']['output'];
  status?: Maybe<REGISTER_STATUS>;
  technicalReview?: Maybe<BackofficeRegisterRatingReview>;
  technicalReviewPoints?: Maybe<Scalars['Int']['output']>;
};

export type BackofficeRegisterQueryResult = {
  __typename?: 'BackofficeRegisterQueryResult';
  data: Array<BackofficeRegister>;
  total: Scalars['Int']['output'];
};

export type BackofficeRegisterRatingReview = {
  __typename?: 'BackofficeRegisterRatingReview';
  authenticityAmount: Scalars['Int']['output'];
  authorship: Scalars['Int']['output'];
  brazilityElements: Scalars['Int']['output'];
  interpretativePerformance: Scalars['Int']['output'];
  visualContentQuality: Scalars['Int']['output'];
};

export enum COMMUNITY_BELONG {
  INDIGENOUS = 'INDIGENOUS',
  NONE = 'NONE',
  NOT_INFORMED = 'NOT_INFORMED',
  OCUPATION = 'OCUPATION',
  QUILOMBOLA = 'QUILOMBOLA',
  SHELTER = 'SHELTER'
}

export type ChangeReviewProcessInput = {
  deadline: Scalars['DateScalar']['input'];
  reviewProcess: REVIEW_PROCESS;
  rhythmDistribution?: InputMaybe<Array<CurationDistributionInput>>;
  technicalDistribution?: InputMaybe<Array<TechincalDistributionInput>>;
};

export type CreateBackofficeUserInput = {
  email: Scalars['String']['input'];
  group: USER_GROUP;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CurationDistributionInput = {
  amount: Scalars['Int']['input'];
  rhythm: Scalars['String']['input'];
};

export type DeleteUserInput = {
  onlyDeactivate?: InputMaybe<Scalars['Boolean']['input']>;
  selfDelete?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ExtraLink = {
  __typename?: 'ExtraLink';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ExtraLinkInput = {
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FileInput = {
  fileName: Scalars['String']['input'];
};

export type FileUploadURL = {
  __typename?: 'FileUploadURL';
  fields: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FinishRegisterDocumentsReviewInput = {
  musicRegisterDocumentsValid?: InputMaybe<Scalars['Boolean']['input']>;
  registerId: Scalars['String']['input'];
  representationDocumentsValid?: InputMaybe<Scalars['Boolean']['input']>;
  usePermissionDocumentsValid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoadRegistersForReviewInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  reviewProcess: REVIEW_PROCESS;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type LoadRegistersQueryInput = {
  currentReviewProcess?: InputMaybe<REVIEW_PROCESS>;
  currentReviewer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<REGISTER_STATUS>;
};

export type Mutation = {
  __typename?: 'Mutation';
  changeReviewProcess: ReviewProcess;
  createBackofficeUser: User;
  deleteUser: SuccessResult;
  finishRegister: Register;
  finishRegisterDocumentsReview: BackofficeRegister;
  finishRegistersRatingReview: SuccessResult;
  generateUploadFileURL: FileUploadURL;
  generate_register_mock?: Maybe<Scalars['Boolean']['output']>;
  register: Register;
  saveRegisterRatingReview: BackofficeRegister;
  setRegisterSelected: BackofficeRegister;
  startRegisterReview: BackofficeRegister;
};


export type MutationchangeReviewProcessArgs = {
  input: ChangeReviewProcessInput;
};


export type MutationcreateBackofficeUserArgs = {
  input: CreateBackofficeUserInput;
};


export type MutationdeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationfinishRegisterDocumentsReviewArgs = {
  input: FinishRegisterDocumentsReviewInput;
};


export type MutationfinishRegistersRatingReviewArgs = {
  reviewProcess: REVIEW_PROCESS;
};


export type MutationgenerateUploadFileURLArgs = {
  input: FileInput;
};


export type MutationregisterArgs = {
  input?: InputMaybe<RegisterInput>;
};


export type MutationsaveRegisterRatingReviewArgs = {
  input: SaveRegisterRatingReviewInput;
};


export type MutationsetRegisterSelectedArgs = {
  input: SetRegisterSelectedInput;
};


export type MutationstartRegisterReviewArgs = {
  input: StartRegisterReviewInput;
};

export type Query = {
  __typename?: 'Query';
  backofficeUsers: Array<User>;
  currentReviewProcess: ReviewProcess;
  loadRegister?: Maybe<Register>;
  loadRegisterStats: RegisterStats;
  loadRegisters: BackofficeRegisterQueryResult;
  loadRegistersForReview: Array<BackofficeRegister>;
};


export type QueryloadRegistersArgs = {
  input: LoadRegistersQueryInput;
};


export type QueryloadRegistersForReviewArgs = {
  input: LoadRegistersForReviewInput;
};

export enum REGISTER_STATUS {
  COMPOSITIONS_AMOUNT_REPROVED = 'COMPOSITIONS_AMOUNT_REPROVED',
  CURATION_FINISHED = 'CURATION_FINISHED',
  DOCUMENTS_APPROVED = 'DOCUMENTS_APPROVED',
  DOCUMENTS_REPROVED = 'DOCUMENTS_REPROVED',
  DRAFT = 'DRAFT',
  FILLED = 'FILLED',
  TECHNICAL_FINISHED = 'TECHNICAL_FINISHED'
}

export enum REPRESENTATION_TYPE {
  EXTERNAL_COMPANY = 'EXTERNAL_COMPANY',
  OWN_COMPANY = 'OWN_COMPANY'
}

export enum REVIEW_PROCESS {
  COMISSION = 'COMISSION',
  CURATION = 'CURATION',
  DOCUMENTS = 'DOCUMENTS',
  TECHNICAL = 'TECHNICAL'
}

export type Register = {
  __typename?: 'Register';
  amountCompositionsOnDigitalPlatforms?: Maybe<AMOUNT_OPTIONS>;
  amountShowsTheLastYear?: Maybe<AMOUNT_OPTIONS>;
  artisticImages?: Maybe<Array<Scalars['String']['output']>>;
  artisticName?: Maybe<Scalars['String']['output']>;
  audioMessageContact?: Maybe<Scalars['Boolean']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  bornCity?: Maybe<Scalars['String']['output']>;
  bornState?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  communityBelong?: Maybe<COMMUNITY_BELONG>;
  discapacity?: Maybe<Scalars['String']['output']>;
  discapacityOther?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  extraLinks?: Maybe<Array<ExtraLink>>;
  featOfDreams?: Maybe<Scalars['String']['output']>;
  finished: Scalars['Boolean']['output'];
  genderIdeology?: Maybe<Scalars['String']['output']>;
  genderIdeologyOther?: Maybe<Scalars['String']['output']>;
  hasExclusiveContract?: Maybe<Scalars['Boolean']['output']>;
  hasExclusiveContractOther?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUs?: Maybe<Scalars['String']['output']>;
  howDidYouHearAboutUsOther?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  miniBio?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  music?: Maybe<RegisterMusic>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  personalPronoun?: Maybe<Scalars['String']['output']>;
  personalPronounOther?: Maybe<Scalars['String']['output']>;
  releaseText?: Maybe<Scalars['String']['output']>;
  representationAgencyDocuments?: Maybe<Array<Scalars['String']['output']>>;
  representationContractDocuments?: Maybe<Array<Scalars['String']['output']>>;
  representationDocuments?: Maybe<Array<Scalars['String']['output']>>;
  representationType?: Maybe<REPRESENTATION_TYPE>;
  rhythm?: Maybe<Array<Scalars['String']['output']>>;
  sexOrientation?: Maybe<Scalars['String']['output']>;
  sexOrientationOther?: Maybe<Scalars['String']['output']>;
  socialNetworkURL?: Maybe<Scalars['String']['output']>;
  step1?: Maybe<Scalars['String']['output']>;
  step2?: Maybe<Scalars['String']['output']>;
  step3?: Maybe<Scalars['String']['output']>;
  step4?: Maybe<Scalars['String']['output']>;
  step5?: Maybe<Scalars['String']['output']>;
  streamingPlatformURLs?: Maybe<Array<Scalars['String']['output']>>;
  textMessageContact?: Maybe<Scalars['Boolean']['output']>;
  videoURL?: Maybe<Scalars['String']['output']>;
};

export type RegisterInput = {
  amountCompositionsOnDigitalPlatforms?: InputMaybe<AMOUNT_OPTIONS>;
  amountShowsTheLastYear?: InputMaybe<AMOUNT_OPTIONS>;
  artisticImages?: InputMaybe<Array<Scalars['String']['input']>>;
  artisticName?: InputMaybe<Scalars['String']['input']>;
  audioMessageContact?: InputMaybe<Scalars['Boolean']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  bornCity?: InputMaybe<Scalars['String']['input']>;
  bornState?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  communityBelong?: InputMaybe<COMMUNITY_BELONG>;
  discapacity?: InputMaybe<Scalars['String']['input']>;
  discapacityOther?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<Scalars['String']['input']>;
  extraLinks?: InputMaybe<Array<ExtraLinkInput>>;
  featOfDreams?: InputMaybe<Scalars['String']['input']>;
  genderIdeology?: InputMaybe<Scalars['String']['input']>;
  genderIdeologyOther?: InputMaybe<Scalars['String']['input']>;
  hasExclusiveContract?: InputMaybe<Scalars['Boolean']['input']>;
  hasExclusiveContractOther?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUs?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearAboutUsOther?: InputMaybe<Scalars['String']['input']>;
  miniBio?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  music?: InputMaybe<RegisterMusicInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  personalPronoun?: InputMaybe<Scalars['String']['input']>;
  personalPronounOther?: InputMaybe<Scalars['String']['input']>;
  releaseText?: InputMaybe<Scalars['String']['input']>;
  representationAgencyDocuments?: InputMaybe<Array<Scalars['String']['input']>>;
  representationContractDocuments?: InputMaybe<Array<Scalars['String']['input']>>;
  representationDocuments?: InputMaybe<Array<Scalars['String']['input']>>;
  representationType?: InputMaybe<REPRESENTATION_TYPE>;
  rhythm?: InputMaybe<Array<Scalars['String']['input']>>;
  sexOrientation?: InputMaybe<Scalars['String']['input']>;
  sexOrientationOther?: InputMaybe<Scalars['String']['input']>;
  socialNetworkURL?: InputMaybe<Scalars['String']['input']>;
  step1?: InputMaybe<Scalars['String']['input']>;
  step2?: InputMaybe<Scalars['String']['input']>;
  step3?: InputMaybe<Scalars['String']['input']>;
  step4?: InputMaybe<Scalars['String']['input']>;
  step5?: InputMaybe<Scalars['String']['input']>;
  streamingPlatformURLs?: InputMaybe<Array<Scalars['String']['input']>>;
  textMessageContact?: InputMaybe<Scalars['Boolean']['input']>;
  videoURL?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterMusic = {
  __typename?: 'RegisterMusic';
  authors?: Maybe<Array<Scalars['String']['output']>>;
  hasAlreadyReleased?: Maybe<Scalars['Boolean']['output']>;
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  lyrics?: Maybe<Scalars['String']['output']>;
  musicRegisterDocuments?: Maybe<Array<Scalars['String']['output']>>;
  musicURL?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  usePermissionDocuments?: Maybe<Array<Scalars['String']['output']>>;
};

export type RegisterMusicInput = {
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAlreadyReleased?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  lyrics?: InputMaybe<Scalars['String']['input']>;
  musicRegisterDocuments?: InputMaybe<Array<Scalars['String']['input']>>;
  musicURL?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  usePermissionDocuments?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RegisterReviewProcessCount = {
  __typename?: 'RegisterReviewProcessCount';
  count: Scalars['Int']['output'];
  reviewProcess?: Maybe<REVIEW_PROCESS>;
};

export type RegisterStats = {
  __typename?: 'RegisterStats';
  reviewProcessCount: Array<RegisterReviewProcessCount>;
  statusCount: Array<RegisterStatusCount>;
  totalCount: Scalars['Int']['output'];
};

export type RegisterStatusCount = {
  __typename?: 'RegisterStatusCount';
  count: Scalars['Int']['output'];
  status: REGISTER_STATUS;
};

export type ReviewProcess = {
  __typename?: 'ReviewProcess';
  deadline: Scalars['DateScalar']['output'];
  reviewProcess: REVIEW_PROCESS;
};

export type SaveRegisterRatingReviewInput = {
  authenticityAmount: Scalars['Int']['input'];
  authorship: Scalars['Int']['input'];
  brazilityElements: Scalars['Int']['input'];
  interpretativePerformance: Scalars['Int']['input'];
  registerId: Scalars['String']['input'];
  reviewProcess: REVIEW_PROCESS;
  visualContentQuality: Scalars['Int']['input'];
};

export type SetRegisterSelectedInput = {
  registerId: Scalars['String']['input'];
  selected: Scalars['Boolean']['input'];
};

export type StartRegisterReviewInput = {
  registerId: Scalars['String']['input'];
  reviewProcess: REVIEW_PROCESS;
};

export type SuccessResult = {
  __typename?: 'SuccessResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TechincalDistributionInput = {
  percentage: Scalars['Int']['input'];
  user: Scalars['String']['input'];
};

export enum USER_GROUP {
  ADMIN = 'ADMIN',
  CURATION_REVIEWER = 'CURATION_REVIEWER',
  DOC_REVIEWER = 'DOC_REVIEWER',
  SYS_ADMIN = 'SYS_ADMIN',
  TECHNICAL_REVIEWER = 'TECHNICAL_REVIEWER'
}

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  group?: Maybe<USER_GROUP>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type RegisterMutationVariables = Exact<{
  input?: InputMaybe<RegisterInput>;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'Register', finished: boolean, step1?: string | null, name?: string | null, birthDate?: string | null, nationality?: string | null, bornState?: string | null, bornCity?: string | null, city?: string | null, neighborhood?: string | null, ethnicity?: string | null, genderIdeology?: string | null, discapacity?: string | null, discapacityOther?: string | null, genderIdeologyOther?: string | null, artisticImages?: Array<string> | null, sexOrientationOther?: string | null, personalPronounOther?: string | null, communityBelong?: COMMUNITY_BELONG | null, sexOrientation?: string | null, personalPronoun?: string | null, email?: string | null, mobileNumber?: string | null, audioMessageContact?: boolean | null, textMessageContact?: boolean | null, step2?: string | null, howDidYouHearAboutUs?: string | null, howDidYouHearAboutUsOther?: string | null, artisticName?: string | null, miniBio?: string | null, releaseText?: string | null, socialNetworkURL?: string | null, videoURL?: string | null, streamingPlatformURLs?: Array<string> | null, amountShowsTheLastYear?: AMOUNT_OPTIONS | null, amountCompositionsOnDigitalPlatforms?: AMOUNT_OPTIONS | null, rhythm?: Array<string> | null, hasExclusiveContract?: boolean | null, hasExclusiveContractOther?: string | null, step3?: string | null, representationType?: REPRESENTATION_TYPE | null, representationContractDocuments?: Array<string> | null, representationDocuments?: Array<string> | null, representationAgencyDocuments?: Array<string> | null, step4?: string | null, step5?: string | null, featOfDreams?: string | null, extraLinks?: Array<{ __typename?: 'ExtraLink', type: string, url: string }> | null, music?: { __typename?: 'RegisterMusic', title?: string | null, authors?: Array<string> | null, hasAlreadyReleased?: boolean | null, musicURL?: string | null, lyrics?: string | null, isRegistered?: boolean | null, musicRegisterDocuments?: Array<string> | null, usePermissionDocuments?: Array<string> | null } | null } };

export type UploadURLMutationVariables = Exact<{
  input: FileInput;
}>;


export type UploadURLMutation = { __typename?: 'Mutation', generateUploadFileURL: { __typename: 'FileUploadURL', url: string, fileName: string, fields: string } };

export type FinishMutationVariables = Exact<{ [key: string]: never; }>;


export type FinishMutation = { __typename?: 'Mutation', finishRegister: { __typename?: 'Register', finished: boolean, step1?: string | null, name?: string | null, birthDate?: string | null, nationality?: string | null, bornState?: string | null, bornCity?: string | null, city?: string | null, neighborhood?: string | null, ethnicity?: string | null, genderIdeology?: string | null, discapacity?: string | null, discapacityOther?: string | null, genderIdeologyOther?: string | null, artisticImages?: Array<string> | null, sexOrientationOther?: string | null, personalPronounOther?: string | null, communityBelong?: COMMUNITY_BELONG | null, sexOrientation?: string | null, personalPronoun?: string | null, email?: string | null, mobileNumber?: string | null, audioMessageContact?: boolean | null, textMessageContact?: boolean | null, step2?: string | null, howDidYouHearAboutUs?: string | null, howDidYouHearAboutUsOther?: string | null, artisticName?: string | null, miniBio?: string | null, releaseText?: string | null, socialNetworkURL?: string | null, videoURL?: string | null, streamingPlatformURLs?: Array<string> | null, amountShowsTheLastYear?: AMOUNT_OPTIONS | null, amountCompositionsOnDigitalPlatforms?: AMOUNT_OPTIONS | null, rhythm?: Array<string> | null, hasExclusiveContract?: boolean | null, hasExclusiveContractOther?: string | null, step3?: string | null, representationType?: REPRESENTATION_TYPE | null, representationContractDocuments?: Array<string> | null, representationDocuments?: Array<string> | null, representationAgencyDocuments?: Array<string> | null, step4?: string | null, step5?: string | null, featOfDreams?: string | null, extraLinks?: Array<{ __typename?: 'ExtraLink', type: string, url: string }> | null, music?: { __typename?: 'RegisterMusic', title?: string | null, authors?: Array<string> | null, hasAlreadyReleased?: boolean | null, musicURL?: string | null, lyrics?: string | null, isRegistered?: boolean | null, musicRegisterDocuments?: Array<string> | null, usePermissionDocuments?: Array<string> | null } | null } };

export type RegisterQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type RegisterQueryQuery = { __typename?: 'Query', loadRegister?: { __typename?: 'Register', finished: boolean, step1?: string | null, name?: string | null, birthDate?: string | null, nationality?: string | null, bornState?: string | null, bornCity?: string | null, city?: string | null, neighborhood?: string | null, ethnicity?: string | null, genderIdeology?: string | null, discapacity?: string | null, discapacityOther?: string | null, genderIdeologyOther?: string | null, artisticImages?: Array<string> | null, sexOrientationOther?: string | null, personalPronounOther?: string | null, communityBelong?: COMMUNITY_BELONG | null, sexOrientation?: string | null, personalPronoun?: string | null, email?: string | null, mobileNumber?: string | null, audioMessageContact?: boolean | null, textMessageContact?: boolean | null, step2?: string | null, howDidYouHearAboutUs?: string | null, howDidYouHearAboutUsOther?: string | null, artisticName?: string | null, miniBio?: string | null, releaseText?: string | null, socialNetworkURL?: string | null, videoURL?: string | null, streamingPlatformURLs?: Array<string> | null, amountShowsTheLastYear?: AMOUNT_OPTIONS | null, amountCompositionsOnDigitalPlatforms?: AMOUNT_OPTIONS | null, rhythm?: Array<string> | null, hasExclusiveContract?: boolean | null, hasExclusiveContractOther?: string | null, step3?: string | null, representationType?: REPRESENTATION_TYPE | null, representationContractDocuments?: Array<string> | null, representationDocuments?: Array<string> | null, representationAgencyDocuments?: Array<string> | null, step4?: string | null, step5?: string | null, featOfDreams?: string | null, extraLinks?: Array<{ __typename?: 'ExtraLink', type: string, url: string }> | null, music?: { __typename?: 'RegisterMusic', title?: string | null, authors?: Array<string> | null, hasAlreadyReleased?: boolean | null, musicURL?: string | null, lyrics?: string | null, isRegistered?: boolean | null, musicRegisterDocuments?: Array<string> | null, usePermissionDocuments?: Array<string> | null } | null } | null };

export type Step1Fragment = { __typename?: 'Register', step1?: string | null, name?: string | null, birthDate?: string | null, nationality?: string | null, bornState?: string | null, bornCity?: string | null, city?: string | null, neighborhood?: string | null, ethnicity?: string | null, genderIdeology?: string | null, discapacity?: string | null, discapacityOther?: string | null, genderIdeologyOther?: string | null, artisticImages?: Array<string> | null, sexOrientationOther?: string | null, personalPronounOther?: string | null, communityBelong?: COMMUNITY_BELONG | null, sexOrientation?: string | null, personalPronoun?: string | null, email?: string | null, mobileNumber?: string | null, audioMessageContact?: boolean | null, textMessageContact?: boolean | null };

export type Step2Fragment = { __typename?: 'Register', step2?: string | null, howDidYouHearAboutUs?: string | null, howDidYouHearAboutUsOther?: string | null, artisticName?: string | null, miniBio?: string | null, releaseText?: string | null, socialNetworkURL?: string | null, videoURL?: string | null, streamingPlatformURLs?: Array<string> | null, amountShowsTheLastYear?: AMOUNT_OPTIONS | null, amountCompositionsOnDigitalPlatforms?: AMOUNT_OPTIONS | null, rhythm?: Array<string> | null, hasExclusiveContract?: boolean | null, hasExclusiveContractOther?: string | null, extraLinks?: Array<{ __typename?: 'ExtraLink', type: string, url: string }> | null };

export type RegisterFragment = { __typename?: 'Register', finished: boolean, step1?: string | null, name?: string | null, birthDate?: string | null, nationality?: string | null, bornState?: string | null, bornCity?: string | null, city?: string | null, neighborhood?: string | null, ethnicity?: string | null, genderIdeology?: string | null, discapacity?: string | null, discapacityOther?: string | null, genderIdeologyOther?: string | null, artisticImages?: Array<string> | null, sexOrientationOther?: string | null, personalPronounOther?: string | null, communityBelong?: COMMUNITY_BELONG | null, sexOrientation?: string | null, personalPronoun?: string | null, email?: string | null, mobileNumber?: string | null, audioMessageContact?: boolean | null, textMessageContact?: boolean | null, step2?: string | null, howDidYouHearAboutUs?: string | null, howDidYouHearAboutUsOther?: string | null, artisticName?: string | null, miniBio?: string | null, releaseText?: string | null, socialNetworkURL?: string | null, videoURL?: string | null, streamingPlatformURLs?: Array<string> | null, amountShowsTheLastYear?: AMOUNT_OPTIONS | null, amountCompositionsOnDigitalPlatforms?: AMOUNT_OPTIONS | null, rhythm?: Array<string> | null, hasExclusiveContract?: boolean | null, hasExclusiveContractOther?: string | null, step3?: string | null, representationType?: REPRESENTATION_TYPE | null, representationContractDocuments?: Array<string> | null, representationDocuments?: Array<string> | null, representationAgencyDocuments?: Array<string> | null, step4?: string | null, step5?: string | null, featOfDreams?: string | null, extraLinks?: Array<{ __typename?: 'ExtraLink', type: string, url: string }> | null, music?: { __typename?: 'RegisterMusic', title?: string | null, authors?: Array<string> | null, hasAlreadyReleased?: boolean | null, musicURL?: string | null, lyrics?: string | null, isRegistered?: boolean | null, musicRegisterDocuments?: Array<string> | null, usePermissionDocuments?: Array<string> | null } | null };

export type Step3Fragment = { __typename?: 'Register', step3?: string | null, representationType?: REPRESENTATION_TYPE | null, representationContractDocuments?: Array<string> | null, representationDocuments?: Array<string> | null, representationAgencyDocuments?: Array<string> | null };

export type Step4Fragment = { __typename?: 'Register', step4?: string | null, music?: { __typename?: 'RegisterMusic', title?: string | null, authors?: Array<string> | null, hasAlreadyReleased?: boolean | null, musicURL?: string | null, lyrics?: string | null, isRegistered?: boolean | null, musicRegisterDocuments?: Array<string> | null, usePermissionDocuments?: Array<string> | null } | null };

export type Step5Fragment = { __typename?: 'Register', step5?: string | null, featOfDreams?: string | null };

export const Step1FragmentDoc = gql`
    fragment Step1 on Register {
  step1
  name
  birthDate
  nationality
  bornState
  bornCity
  city
  neighborhood
  ethnicity
  genderIdeology
  discapacity
  discapacityOther
  genderIdeologyOther
  artisticImages
  sexOrientationOther
  personalPronounOther
  communityBelong
  sexOrientation
  personalPronoun
  email
  mobileNumber
  audioMessageContact
  textMessageContact
}
    `;
export const Step2FragmentDoc = gql`
    fragment Step2 on Register {
  step2
  howDidYouHearAboutUs
  howDidYouHearAboutUsOther
  artisticName
  miniBio
  releaseText
  socialNetworkURL
  videoURL
  streamingPlatformURLs
  extraLinks {
    type
    url
  }
  amountShowsTheLastYear
  amountCompositionsOnDigitalPlatforms
  rhythm
  hasExclusiveContract
  hasExclusiveContractOther
}
    `;
export const Step3FragmentDoc = gql`
    fragment Step3 on Register {
  step3
  representationType
  representationContractDocuments
  representationDocuments
  representationAgencyDocuments
}
    `;
export const Step4FragmentDoc = gql`
    fragment Step4 on Register {
  step4
  music {
    title
    authors
    hasAlreadyReleased
    musicURL
    lyrics
    isRegistered
    musicRegisterDocuments
    usePermissionDocuments
  }
}
    `;
export const Step5FragmentDoc = gql`
    fragment Step5 on Register {
  step5
  featOfDreams
}
    `;
export const RegisterFragmentDoc = gql`
    fragment Register on Register {
  finished
  ...Step1
  ...Step2
  ...Step3
  ...Step4
  ...Step5
}
    ${Step1FragmentDoc}
${Step2FragmentDoc}
${Step3FragmentDoc}
${Step4FragmentDoc}
${Step5FragmentDoc}`;
export const RegisterDocument = gql`
    mutation Register($input: RegisterInput) {
  register(input: $input) {
    ...Register
  }
}
    ${RegisterFragmentDoc}`;
export const UploadURLDocument = gql`
    mutation UploadURL($input: FileInput!) {
  generateUploadFileURL(input: $input) {
    url
    fileName
    fields
    __typename
  }
}
    `;
export const FinishDocument = gql`
    mutation Finish {
  finishRegister {
    ...Register
  }
}
    ${RegisterFragmentDoc}`;
export const RegisterQueryDocument = gql`
    query RegisterQuery {
  loadRegister {
    ...Register
  }
}
    ${RegisterFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Register(variables?: RegisterMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegisterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterMutation>(RegisterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Register', 'mutation', variables);
    },
    UploadURL(variables: UploadURLMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UploadURLMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadURLMutation>(UploadURLDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UploadURL', 'mutation', variables);
    },
    Finish(variables?: FinishMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinishMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinishMutation>(FinishDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Finish', 'mutation', variables);
    },
    RegisterQuery(variables?: RegisterQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegisterQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterQueryQuery>(RegisterQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RegisterQuery', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;